import React, { useRef, useEffect, useState, useCallback } from 'react';
import { gsap } from 'gsap';
import { ScrollTrigger } from 'gsap/ScrollTrigger';
import './Reviews.css';

gsap.registerPlugin(ScrollTrigger);

const reviews = [
  {
    quote: 'The ambience is super relaxing with a clean, minimal vibe.',
    author: 'JD',
    platform: 'Google',
  },
  {
    quote: 'The service is really quick, friendly staff.',
    author: 'Chetas Mapara',
    platform: 'Google',
  },
  {
    quote: 'We tried Saffron tonight, and it was absolutely fantastic! Anyone who knows me knows how much I love Indian food, and this place did not disappoint. We ordered the chicken tikka masala, chicken korma, and lamb saag — every dish was incredible.',
    author: 'Bakersfield Foodie',
    platform: 'Google',
  },
  {
    quote: 'My husband and I had an early supper today at this newly opened restaurant. The food was delicious and the service was excellent.',
    author: 'Sukhwinder G.',
    platform: 'Google',
  },
  {
    quote: 'Absolutely love this place! The butter chicken is the best I have had. The naan is fresh and perfectly charred from the tandoor. Will be coming back every week.',
    author: 'Priya M.',
    platform: 'Yelp',
  },
  {
    quote: 'Beautiful atmosphere, amazing cocktails, and the food is authentic and flavorful. Perfect date night spot in Bakersfield. The lamb saag and garlic naan were outstanding.',
    author: 'Sarah K.',
    platform: 'Yelp',
  },
  {
    quote: 'Best Indian food in Bakersfield, hands down. The lunch buffet is incredible — so many options and everything is fresh. The staff treats you like family.',
    author: 'Mike R.',
    platform: 'Google',
  },
  {
    quote: 'Finally a real Indian restaurant with a full bar in Bakersfield! The mango chili margarita is a must-try. Food is 10/10.',
    author: 'Alex T.',
    platform: 'Yelp',
  },
  {
    quote: 'We ordered catering trays for our son\'s birthday party and the food was a massive hit. The paneer tikka and chicken biryani trays were finished in minutes. Will definitely order again.',
    author: 'Harpreet S.',
    platform: 'Google',
  },
  {
    quote: 'The goat curry here is the real deal — reminds me of my mom\'s cooking back home. Rich, slow-cooked, perfectly spiced. Nothing else in Bakersfield comes close.',
    author: 'Ravi P.',
    platform: 'Google',
  },
  {
    quote: 'Took my team here for a work dinner and everyone was impressed. The tandoori platter was the star of the night. Great cocktails too — the tamarind whiskey sour is something else.',
    author: 'Jennifer L.',
    platform: 'Yelp',
  },
  {
    quote: 'This place is a gem. We come every Friday night now. The malai kofta is creamy perfection, and the kids love the cheese naan. So glad we found Saffron.',
    author: 'Amanda & David',
    platform: 'Google',
  },
  {
    quote: 'Ordered the chole bhature for the first time and I\'m hooked. The bhatura was so fluffy and the chole had that deep home-cooked flavor. Great portions for the price too.',
    author: 'Simran K.',
    platform: 'Yelp',
  },
  {
    quote: 'Celebrated our anniversary here and the staff went above and beyond. They decorated our table and the lamb chops were cooked to perfection. Five stars all around.',
    author: 'Carlos M.',
    platform: 'Google',
  },
  {
    quote: 'The masala dosa was crispy and the sambar was legit South Indian. So happy to find a place in Bakersfield that does both North and South Indian food well.',
    author: 'Anitha R.',
    platform: 'Yelp',
  },
  {
    quote: 'We hosted our baby shower here and the party trays were incredible. The dal makhani and garlic naan combo is unbeatable. Everyone kept asking where the food was from.',
    author: 'Neha T.',
    platform: 'Google',
  },
];

const platforms = [
  {
    name: 'Google',
    rating: '4.9',
    count: 44,
    icon: (
      <svg width="22" height="22" viewBox="0 0 24 24" fill="currentColor" aria-hidden="true">
        <path d="M12.48 10.92v3.28h7.84c-.24 1.84-.853 3.187-1.787 4.133-1.147 1.147-2.933 2.4-6.053 2.4-4.827 0-8.6-3.893-8.6-8.72s3.773-8.72 8.6-8.72c2.6 0 4.507 1.027 5.907 2.347l2.307-2.307C18.747 1.44 16.133 0 12.48 0 5.867 0 .307 5.387.307 12s5.56 12 12.173 12c3.573 0 6.267-1.173 8.373-3.36 2.16-2.16 2.84-5.213 2.84-7.667 0-.76-.053-1.467-.173-2.053H12.48z" />
      </svg>
    ),
    url: 'https://maps.google.com/?q=Saffron+Indian+Food+%26+Bar+Bakersfield',
  },
  {
    name: 'Yelp',
    rating: '5.0',
    count: 23,
    icon: (
      <svg width="22" height="22" viewBox="0 0 24 24" fill="currentColor" aria-hidden="true">
        <path d="m7.6885 15.1415-3.6715.8483c-.3769.0871-.755.183-1.1452.155-.2611-.0188-.5122-.0414-.7606-.213a1.179 1.179 0 0 1-.331-.3594c-.3486-.5519-.3656-1.3661-.3697-2.0004a6.2874 6.2874 0 0 1 .3314-2.0642 1.857 1.857 0 0 1 .1073-.2474 2.3426 2.3426 0 0 1 .1255-.2165 2.4572 2.4572 0 0 1 .1563-.1975 1.1736 1.1736 0 0 1 .399-.2831 1.082 1.082 0 0 1 .4592-.0837c.2355.0016.5139.052.91.1734.0555.0191.1237.0382.1856.0572.3277.1013.7048.2404 1.1499.3987.6863.2404 1.3663.487 2.0463.7397l1.2117.4423c.2217.0807.4363.18.6412.297.174.0984.3273.2298.4512.387a1.217 1.217 0 0 1 .192.4309 1.2205 1.2205 0 0 1-.872 1.4522c-.0468.0151-.0852.0239-.1085.0293l-1.105.2553zM18.8208 7.565a1.8506 1.8506 0 0 0-.2042-.1754 2.4082 2.4082 0 0 0-.2077-.1394 2.3607 2.3607 0 0 0-.2269-.109 1.1705 1.1705 0 0 0-.482-.0796 1.0862 1.0862 0 0 0-.4498.1263c-.2107.1048-.4388.2732-.742.5551-.042.0417-.0947.0886-.142.133-.2502.2351-.5286.5252-.8599.863a114.6363 114.6363 0 0 0-1.5166 1.5629l-.8962.9293a4.1897 4.1897 0 0 0-.4466.5483 1.541 1.541 0 0 0-.2364.5459 1.2199 1.2199 0 0 0 .0107.4518l.0046.02a1.218 1.218 0 0 0 1.4184.923 1.162 1.162 0 0 0 .1105-.0213l4.7781-1.104c.3766-.087.7587-.1667 1.097-.3631.2269-.1316.4428-.262.5909-.5252a1.1793 1.1793 0 0 0 .1405-.4683c.0733-.6512-.2668-1.3908-.5403-1.963a6.2792 6.2792 0 0 0-1.2001-1.7103zM8.9703.0754a8.6724 8.6724 0 0 0-.83.1564c-.2754.066-.548.1383-.8146.2236-.868.2844-2.0884.8063-2.295 1.8065-.1165.5655.1595 1.1439.3737 1.66.2595.6254.614 1.1889.9373 1.7777.8543 1.5545 1.7245 3.0993 2.5922 4.6457.259.4617.5416 1.0464 1.043 1.2856a1.058 1.058 0 0 0 .1013.0383c.2248.0851.4699.1016.7041.0471a4.3015 4.3015 0 0 0 .0418-.0097 1.2136 1.2136 0 0 0 .5658-.3397 1.1033 1.1033 0 0 0 .079-.0822c.3463-.435.3454-1.0833.3764-1.6134.1042-1.771.2139-3.5423.3009-5.3142.0332-.6712.1055-1.3333.0655-2.0096-.0328-.5579-.0368-1.1984-.3891-1.6563-.6218-.8073-1.9476-.741-2.8523-.6158zm2.084 15.9505a1.1053 1.1053 0 0 0-1.2306-.4145 1.1398 1.1398 0 0 0-.1526.0633 1.4806 1.4806 0 0 0-.2171.1354c-.1992.1475-.3668.3392-.5196.5315-.0386.049-.074.1143-.12.1562l-.7686 1.0573a113.9168 113.9168 0 0 0-1.2913 1.789c-.278.3895-.5184.7184-.7083 1.0094-.036.0547-.0734.116-.1075.1647-.2277.3522-.3566.6092-.4228.8381a1.0945 1.0945 0 0 0-.046.4721c.0211.1655.0768.3246.1635.467.046.0715.0957.1406.1487.207a2.334 2.334 0 0 0 .1754.1825 1.843 1.843 0 0 0 .2108.1732c.5304.369 1.1112.6342 1.722.8391a6.0958 6.0958 0 0 0 1.5716.3004c.091.0046.1821.0025.2728-.006a2.3878 2.3878 0 0 0 .2506-.0351 2.3862 2.3862 0 0 0 .2447-.071 1.1927 1.1927 0 0 0 .4175-.2658c.1127-.113.1994-.249.2541-.3989.0889-.2214.1473-.5026.1857-.92.0034-.0593.0118-.1305.0177-.1958.0304-.3463.0443-.7531.0666-1.2315.0375-.7357.067-1.4681.0903-2.2026 0 0 .0495-1.3053.0494-1.306.0113-.3008.002-.6342-.0814-.9336a1.396 1.396 0 0 0-.1756-.4054zm8.6754 2.0439c-.1605-.176-.3878-.3514-.7462-.5682-.0518-.0288-.1124-.0674-.1684-.1009-.2985-.1795-.658-.3684-1.078-.5965a120.7615 120.7615 0 0 0-1.9427-1.042l-1.1515-.6107c-.0597-.0175-.1203-.0607-.1766-.0878-.2212-.1058-.4558-.2045-.6992-.2498a1.4915 1.4915 0 0 0-.2545-.0265 1.1527 1.1527 0 0 0-.1648.01 1.1077 1.1077 0 0 0-.9227.9133 1.4186 1.4186 0 0 0 .0159.439c.0563.3065.1932.6096.3346.875l.615 1.1526c.3422.65.6884 1.2963 1.0435 1.9406.229.4202.4196.7799.5982 1.078.0338.056.0721.1163.1011.1682.2173.3584.392.584.569.7458.1146.1107.252.195.4026.247.1583.0525.326.071.4919.0546a2.368 2.368 0 0 0 .251-.0435c.0817-.022.1622-.048.241-.0784a1.863 1.863 0 0 0 .2475-.1143 6.1018 6.1018 0 0 0 1.2818-.9597c.4596-.4522.8659-.9454 1.182-1.51.044-.08.0819-.163.1138-.2483a2.49 2.49 0 0 0 .0773-.2411c.0186-.083.033-.1669.0429-.2513a1.188 1.188 0 0 0-.0565-.491 1.0933 1.0933 0 0 0-.248-.4041z" />
      </svg>
    ),
    url: 'https://www.yelp.com/biz/saffron-indian-food-and-bar-bakersfield-2',
  },
];

const VISIBLE_COUNT = 3;
const ROTATE_INTERVAL = 5000;

function StarIcon() {
  return (
    <svg
      className="reviews__star"
      width="16"
      height="16"
      viewBox="0 0 24 24"
      fill="var(--saffron)"
      aria-hidden="true"
    >
      <path d="M12 2l3.09 6.26L22 9.27l-5 4.87 1.18 6.88L12 17.77l-6.18 3.25L7 14.14 2 9.27l6.91-1.01L12 2z" />
    </svg>
  );
}

function Reviews() {
  const sectionRef = useRef(null);
  const badgesRef = useRef([]);
  const cardsContainerRef = useRef(null);
  const [activeIndex, setActiveIndex] = useState(0);

  const nextSlide = useCallback(() => {
    setActiveIndex((prev) => (prev + 1) % reviews.length);
  }, []);

  useEffect(() => {
    const interval = setInterval(nextSlide, ROTATE_INTERVAL);
    return () => clearInterval(interval);
  }, [nextSlide]);

  // GSAP transition on slide change
  useEffect(() => {
    if (!cardsContainerRef.current) return;
    const cards = cardsContainerRef.current.querySelectorAll('.reviews__card');
    if (!cards.length) return;

    cards.forEach((card) => {
      gsap.to(card, { opacity: 0, y: 15, duration: 0.3, ease: 'power2.in' });
    });

    // After fade out, update visible cards and fade in
    const timeout = setTimeout(() => {
      cards.forEach((card, i) => {
        gsap.fromTo(
          card,
          { opacity: 0, y: 20 },
          { opacity: 1, y: 0, duration: 0.5, delay: i * 0.12, ease: 'power2.out' },
        );
      });
    }, 300);

    return () => clearTimeout(timeout);
  }, [activeIndex]);

  // Entrance animation for badges
  useEffect(() => {
    const ctx = gsap.context(() => {
      const validBadges = badgesRef.current.filter(Boolean);
      if (validBadges.length > 0) {
        gsap.fromTo(
          validBadges,
          { opacity: 0, y: 30, scale: 0.95 },
          {
            opacity: 1,
            y: 0,
            scale: 1,
            duration: 0.7,
            stagger: 0.15,
            ease: 'power3.out',
            scrollTrigger: {
              trigger: validBadges[0],
              start: 'top 88%',
              toggleActions: 'play none none none',
            },
          },
        );
      }
    }, sectionRef);

    return () => ctx.revert();
  }, []);

  // Get the 3 visible reviews based on activeIndex
  const getVisibleReviews = () => {
    const visible = [];
    for (let i = 0; i < VISIBLE_COUNT; i++) {
      visible.push(reviews[(activeIndex + i) % reviews.length]);
    }
    return visible;
  };

  const visibleReviews = getVisibleReviews();

  return (
    <section id="reviews" className="reviews" ref={sectionRef}>
      <div className="reviews__container">
        <div className="reviews__header reveal">
          <span className="eyebrow">What People Say</span>
          <h2>
            Loved by <em>Bakersfield</em>
          </h2>
          <div className="gold-divider">
            <span className="dot"></span>
          </div>
        </div>

        <div className="reviews__badges">
          {platforms.map((platform, i) => (
            <a
              key={platform.name}
              href={platform.url}
              target="_blank"
              rel="noopener noreferrer"
              className="reviews__badge"
              ref={(el) => {
                badgesRef.current[i] = el;
              }}
            >
              <span className="reviews__badge-icon">{platform.icon}</span>
              <span className="reviews__badge-info">
                <span className="reviews__badge-rating">
                  {platform.rating}
                  <span className="reviews__badge-stars">
                    {Array.from({ length: 5 }).map((_, j) => (
                      <StarIcon key={j} />
                    ))}
                  </span>
                </span>
                <span className="reviews__badge-meta">
                  {platform.count} reviews on {platform.name}
                </span>
              </span>
            </a>
          ))}
        </div>

        <div className="reviews__grid" ref={cardsContainerRef}>
          {visibleReviews.map((review, i) => (
            <blockquote key={`${activeIndex}-${i}`} className="reviews__card">
              <div className="reviews__card-stars" aria-label="5 out of 5 stars">
                {Array.from({ length: 5 }).map((_, j) => (
                  <StarIcon key={j} />
                ))}
              </div>
              <p className="reviews__card-quote">&ldquo;{review.quote}&rdquo;</p>
              <footer className="reviews__card-footer">
                <cite className="reviews__card-author">&mdash; {review.author}</cite>
                <span className="reviews__card-platform">{review.platform}</span>
              </footer>
            </blockquote>
          ))}
        </div>

        {/* Dot indicators */}
        <div className="reviews__dots">
          {reviews.map((_, i) => (
            <button
              key={i}
              className={`reviews__dot ${i === activeIndex ? 'reviews__dot--active' : ''}`}
              onClick={() => setActiveIndex(i)}
              aria-label={`Show review ${i + 1}`}
            />
          ))}
        </div>
      </div>
    </section>
  );
}

export default Reviews;
